import { Button } from '@mui/material'
import useConnectWallet from '@/components/common/ConnectWallet/useConnectWallet'
import { useEffect } from 'react'

// Función auxiliar para marcar el estado del modal
const markModalState = (isOpen: boolean) => {
  if (isOpen) {
    document.body.setAttribute('data-modal-open', 'true')
  } else {
    document.body.removeAttribute('data-modal-open')
  }

  // También ocultar directamente los elementos del logo móvil
  const logoElements = document.querySelectorAll('.logoMobile')
  logoElements.forEach((el) => {
    ;(el as HTMLElement).style.display = isOpen ? 'none' : ''
  })
}

const ConnectWalletButton = ({
  onConnect,
  contained = true,
  small = false,
  text,
}: {
  onConnect?: () => void
  contained?: boolean
  small?: boolean
  text?: string
}): React.ReactElement => {
  const connectWallet = useConnectWallet()

  // Asegurarse de que el estado del modal se limpie al desmontar el componente
  useEffect(() => {
    // Al montar, verificar si hay un modal activo
    const hasModal =
      document.querySelector('.w3o-modal') !== null ||
      document.querySelector('[class*="w3o"]') !== null ||
      document.querySelector('.ReactModal__Overlay') !== null
    markModalState(hasModal)

    // Cleanup al desmontar
    return () => {
      markModalState(false)
    }
  }, [])

  const handleConnect = () => {
    // Marcar que el modal está abierto
    markModalState(true)

    // Llamar al callback original si existe
    onConnect?.()

    // Conectar la wallet
    connectWallet().finally(() => {
      // Verificar si el modal sigue abierto después de la conexión
      setTimeout(() => {
        const stillHasModal =
          document.querySelector('.w3o-modal') !== null ||
          document.querySelector('[class*="w3o"]') !== null ||
          document.querySelector('.ReactModal__Overlay') !== null

        // Si el modal se ha cerrado, restaurar el logo
        if (!stillHasModal) {
          markModalState(false)
        }
      }, 100)
    })
  }

  return (
    <Button
      data-testid="connect-wallet-btn"
      onClick={handleConnect}
      variant={contained ? 'contained' : 'text'}
      size={small ? 'small' : 'medium'}
      disableElevation
      fullWidth
      sx={{ fontSize: small ? ['12px', '13px'] : '' }}
    >
      {text || 'Connect'}
    </Button>
  )
}

export default ConnectWalletButton
